import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface WorkbookStateChange {
  type: 'update' | 'add' | 'delete';
  workbookId: string;
  data: any;
  columnId?: string;
  columnName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class WorkbookStateService {
  private stateChangeSubject = new BehaviorSubject<WorkbookStateChange | null>(null);
  stateChange$ = this.stateChangeSubject.asObservable();

  // Method to notify about state changes
  notifyStateChange(change: WorkbookStateChange) {
    this.stateChangeSubject.next(change);
  }

  // Method to clear state
  clearState() {
    this.stateChangeSubject.next(null);
  }
} 